const siniestro = [
    {
        key: "nroSiniestro",
        label: "Nro. Siniestro",
        sortable: true,
    },
    {
        key: "descGravedad",
        label: "Gravedad",
        sortable: true,
    },
    {
        key: "patente",
        label: "Patente",
        sortable: true,
    },
    {
        key: "fecIngreso",
        label: "Fecha de Ingreso",
        sortable: true,
    },
    {
        key: "rutConductor",
        label: "ID Conductor",
        sortable: true,
    },
    {
        key: "nombreConductor",
        label: "Nombre conductor",
        sortable: true,
    },
    {
        key: "fecAccidente",
        label: "Fecha Accidente",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    }

];

const siniestrosLOP = [
    {
        key: "nroSiniestro",
        label: "Nro. Siniestro",
        sortable: true,
    },
    {
        key: "descGravedad",
        label: "Gravedad",
        sortable: true,
    },
    {
        key: "patente",
        label: "Patente",
        sortable: true,
    },
    {
        key: "fecIngreso",
        label: "Fecha de declaracion de siniestro",
        sortable: true,
    },
    {
        key: "rutConductor",
        label: "RUT",
        sortable: true,
    },
    {
        key: "nombreConductor",
        label: "Nombre conductor",
        sortable: true,
    },
    {
        key: "fecAccidente",
        label: "Fecha Accidente",
        sortable: true,
    },
    {
        key: "ingresoTaller",
        label: "¿Ingreso a taller?",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    }

];

module.exports = {
    siniestro,
    siniestrosLOP
};
